import React from 'react';


const Footer = () => {
    return(<>
   <footer className="w-100 bg-light text-center">
   <p> <b> ©  WP Works 2020. All Rights Reserved ! Terms & Conditions </b> </p>
   
    </footer>
    </>);
};
export default Footer;